import { DISCOVER_ACTION_TYPES } from '../actions/types';

const initialState = {
  // Featured Profiles
  featuredProfiles: [],
  loadingFeatured: false,
  featuredError: null,
  
  // All Creators
  allCreators: [],
  loadingCreators: false,
  creatorsError: null,
  
  // Categories
  categories: [],
  loadingCategories: false,
  categoriesError: null,
  currentCategoryPage: 0,
  
  // Recommended Profiles
  allRecommendedProfiles: [],
  loadingRecommended: false,
  recommendedError: null,
  currentRecommendedPage: 0,
  
  // Trending Profiles
  trendingProfiles: [],
  loadingTrending: false,
  trendingError: null,
  
  // General state
  isInitialized: false,
  lastFetchTime: null,
  fetchedForAuthState: null, // Track whether data was fetched for authenticated or guest user
};

const discoverReducer = (state = initialState, action) => {
  switch (action.type) {
    // Featured Profiles
    case DISCOVER_ACTION_TYPES.FETCH_FEATURED_PROFILES_REQUEST:
      return {
        ...state,
        loadingFeatured: true,
        featuredError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_FEATURED_PROFILES_SUCCESS:
      return {
        ...state,
        loadingFeatured: false,
        featuredProfiles: action.payload,
        featuredError: null,
        isInitialized: true,
        lastFetchTime: Date.now(),
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_FEATURED_PROFILES_FAILURE:
      return {
        ...state,
        loadingFeatured: false,
        featuredError: action.payload,
      };
    
    // All Creators
    case DISCOVER_ACTION_TYPES.FETCH_ALL_CREATORS_REQUEST:
      return {
        ...state,
        loadingCreators: true,
        creatorsError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_ALL_CREATORS_SUCCESS:
      return {
        ...state,
        loadingCreators: false,
        allCreators: action.payload,
        creatorsError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_ALL_CREATORS_FAILURE:
      return {
        ...state,
        loadingCreators: false,
        creatorsError: action.payload,
      };
    
    // Categories
    case DISCOVER_ACTION_TYPES.FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loadingCategories: true,
        categoriesError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loadingCategories: false,
        categories: action.payload,
        categoriesError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loadingCategories: false,
        categoriesError: action.payload,
      };
    
    // Recommended Profiles
    case DISCOVER_ACTION_TYPES.FETCH_RECOMMENDED_PROFILES_REQUEST:
      return {
        ...state,
        loadingRecommended: true,
        recommendedError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_RECOMMENDED_PROFILES_SUCCESS:
      return {
        ...state,
        loadingRecommended: false,
        allRecommendedProfiles: action.payload,
        recommendedError: null,
        currentRecommendedPage: 0, // Reset to first page on refresh
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_RECOMMENDED_PROFILES_FAILURE:
      return {
        ...state,
        loadingRecommended: false,
        recommendedError: action.payload,
      };
    
    // Trending Profiles
    case DISCOVER_ACTION_TYPES.FETCH_TRENDING_PROFILES_REQUEST:
      return {
        ...state,
        loadingTrending: true,
        trendingError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_TRENDING_PROFILES_SUCCESS:
      return {
        ...state,
        loadingTrending: false,
        trendingProfiles: action.payload,
        trendingError: null,
      };
    
    case DISCOVER_ACTION_TYPES.FETCH_TRENDING_PROFILES_FAILURE:
      return {
        ...state,
        loadingTrending: false,
        trendingError: action.payload,
      };
    
    // Update Follow Status
    case DISCOVER_ACTION_TYPES.UPDATE_FOLLOW_STATUS:
      return {
        ...state,
        allCreators: state.allCreators.map(creator =>
          creator._id === action.payload.creatorId
            ? { ...creator, isFollowing: action.payload.isFollowing }
            : creator
        ),
        featuredProfiles: state.featuredProfiles.map(profile =>
          profile._id === action.payload.creatorId
            ? { ...profile, isFollowing: action.payload.isFollowing }
            : profile
        ),
        allRecommendedProfiles: state.allRecommendedProfiles.map(profile =>
          profile._id === action.payload.creatorId
            ? { ...profile, isFollowing: action.payload.isFollowing }
            : profile
        ),
        trendingProfiles: state.trendingProfiles.map(profile =>
          profile._id === action.payload.creatorId
            ? { ...profile, isFollowing: action.payload.isFollowing }
            : profile
        ),
      };
    
    // Pagination
    case DISCOVER_ACTION_TYPES.SET_CATEGORY_PAGE:
      return {
        ...state,
        currentCategoryPage: action.payload,
      };
    
    case DISCOVER_ACTION_TYPES.SET_RECOMMENDED_PAGE:
      return {
        ...state,
        currentRecommendedPage: action.payload,
      };
    
    // Set auth state
    case DISCOVER_ACTION_TYPES.SET_AUTH_STATE:
      return {
        ...state,
        fetchedForAuthState: action.payload.isGuestUser ? 'guest' : 'authenticated',
      };
    
    // Clear data
    case DISCOVER_ACTION_TYPES.CLEAR_DISCOVER_DATA:
      return initialState;
    
    default:
      return state;
  }
};

export default discoverReducer;

